export default "__VITE_ASSET__13f1abc0__"